import { useAtom } from "jotai";
import { useEffect, useState } from "react";

import { InternalLink } from "@sorcery/ui";

import { bannerJotai } from "~/state/configJotai";
import { dragonlordPath } from "~/utils/paths";

export const Banner = () => {
  const [ready, setReady] = useState(false);
  const [seenBanner, setSeenBanner] = useAtom(bannerJotai);
  useEffect(() => {
    setReady(true);
  }, []);

  const bannerOn = true;
  const currentBanner = "dragonlord";

  return bannerOn && seenBanner !== currentBanner && ready ? (
    <InternalLink href={dragonlordPath}>
      <div className="flex h-10 items-center gap-x-2 overflow-hidden bg-black px-6 py-2 font-title sm:px-3.5 sm:before:flex-1">
        <div className="mx-4 flex items-center duration-300 hover:opacity-50">
          <p className="whitespace-nowrap leading-6 text-white">
            <strong className="font-bold">The Dragonlord has awakened</strong>
            {/* sm screen */}
            {/* <span className="inline sm:hidden">
              <svg
                viewBox="0 0 2 2"
                className="mx-2 inline h-0.5 w-0.5 fill-current"
                aria-hidden="true"
              >
                <circle cx="1" cy="1" r="1" />
              </svg>
              <span>Sorcery's epic mini set!</span>
            </span> */}
            {/* big screen */}
            <span className="hidden md:inline">
              <svg
                viewBox="0 0 2 2"
                className="mx-2 inline h-0.5 w-0.5 fill-current"
                aria-hidden="true"
              >
                <circle cx="1" cy="1" r="1" />
              </svg>
              <span>Discover Sorcery's epic mini set </span>
            </span>
          </p>
        </div>
        <div className="flex flex-1 justify-end">
          <button
            type="button"
            className="-m-3 p-6 transition-opacity hover:opacity-40 focus-visible:outline-offset-[-4px]"
            onClick={(e) => {
              setSeenBanner(currentBanner);
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <span className="sr-only">Dismiss</span>
            <svg
              className="h-5 w-5 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
            </svg>
          </button>
        </div>
      </div>
    </InternalLink>
  ) : null;
};
